<template>
  <div class="d-flex flex-row justify-content-center">
    <a class="ml-3 mr-1 black-link"><mdb-icon icon="bell" @click.native="show = true"/><span v-if="complaints.length > 0" class="counter">{{ complaints.length }}</span></a>
    <a class="ml-1 mr-3 black-link"><mdb-icon icon="plus" @click.native="addComplaint"/></a>
    <mdb-modal :show="show" @close="show = false">
      <mdb-modal-header class="aqua-gradient">
        <mdb-modal-title>Complaints</mdb-modal-title>
      </mdb-modal-header>
      <mdbModalBody class="complaints-modal-body">
        <mdb-card
          v-for="(complaint, index) in complaints"
          :key="`card-${index}`"
          class="mb-3"
        >
          <mdb-card-body>
            <p>{{ complaint.description }}</p>
            <mdb-collapse :toggleTag="['a']" :togglers="1" :toggleClass="['btn btn-primary btn-sm rounded']" :toggleText="['DATA (JSON)']">
              <h5>Data</h5>
              <p>{{ complaint.data }}</p>
            </mdb-collapse>
          </mdb-card-body>
          <mdb-card-footer color="mdb-color" class="lighten-3 p-0 text-center">
            <ul class="list-unstyled list-inline font-small mt-3">
              <li class="list-inline-item pr-2 white-text">
                <mdb-icon icon="clock" class="pr-1" />{{ formatDateTime(complaint.created) }}</li>
              <li v-if="complaint.author" class="list-inline-item pr-2"><span class="white-text">
                <mdb-icon icon="user" class="pr-1" />{{ complaint.author }}</span></li>
              <li v-if="isAdmin" class="list-inline-item pr-2 white-text">
                <mdb-btn
                  rounded
                  gradient="sunny-morning"
                  size="sm"
                  icon="trash"
                  title="Delete this complaint"
                  @click.native="deleteComplaint(complaint.uuid)"
                /></li>
            </ul>
          </mdb-card-footer>
        </mdb-card>
      </mdbModalBody>
    </mdb-modal>
  </div>
</template>

<script>
import {mapGetters, mapActions, mapState} from 'vuex'
import {
  mdbModal,
  mdbModalHeader,
  mdbModalTitle,
  mdbModalBody,
  mdbModalFooter,
  mdbCollapse,
  mdbCard,
  mdbCardBody,
  mdbCardFooter,
  mdbIcon,
  mdbBtn
} from 'mdbvue'
import {errorCatch, formatDT} from '../utils'

export default {
  name: 'Complaints',
  data () {
    return {
      show: false,
      complaints: []
    }
  },
  computed: {
    ...mapGetters('user', ['isAdmin']),
    ...mapState('user', {
      username: state => state.username
    }),
    ...mapState('calc', {
      query: state => state.query,
      measureUnits: state => state.data.measureUnits,
      rates: state => state.ratesData,
      cargo: state => state.cargo
    })
  },
  methods: {
    ...mapActions(['apiComplaintsGet', 'apiComplaintCreate', 'apiComplaintDelete']),
    addComplaint () {
      this.$bus.$emit('modal-textarea', text => {
        const data = {
          description: text,
          author: this.username || null,
          data: JSON.stringify({
            query: this.query,
            measureUnits: this.measureUnits,
            cargo: this.cargo,
            rates: this.rates
          }, null, 2)
        }
        this.apiComplaintCreate(data)
          .then(() => {
            this.$notify.success({
              title: 'Complaint created.',
              message: '',
              position: 'top right',
              timeOut: 5000,
              closeButton: true
            })
            this.apiComplaintsGet()
              .then(complaints => {
                this.complaints = complaints
              })
              .catch(errorCatch('Get Complaints Failed'))
          })
          .catch(errorCatch('Complaint Creation Failed', this))
      })
    },
    deleteComplaint (uuid) {
      this.apiComplaintDelete(uuid)
        .then(() => {
          this.apiComplaintsGet()
            .then(complaints => {
              this.complaints = complaints
            })
            .catch(errorCatch('Get Complaints Failed', this))
        })
        .catch(errorCatch('Delete Complaint Failed', this))
    },
    formatDateTime (dtObj) {
      return formatDT(dtObj)
    }
  },
  mounted () {
    this.apiComplaintsGet()
      .then(complaints => {
        this.complaints = complaints
      })
      .catch(errorCatch('Get Complaints Failed', this))
  },
  components: {
    mdbModal,
    mdbModalHeader,
    mdbModalTitle,
    mdbModalBody,
    mdbModalFooter,
    mdbCard,
    mdbCardBody,
    mdbCardFooter,
    mdbCollapse,
    mdbIcon,
    mdbBtn
  }
}
</script>

<style lang="sass" scoped>
.complaints-modal-body
  overflow: auto
</style>



// WEBPACK FOOTER //
// src/components/Complaints.vue